<template>
  <v-card height="100%" elevation="9">
    <v-card-title id="module-selector-label">Select Module</v-card-title>
    <v-card-actions>
      <v-select
        :model-value="currentModule"
        @update:model-value="$emit('update:currentModule', $event)"
        :items="moduleNames"
        aria-labelledby="module-selector-label"
      />
    </v-card-actions>
  </v-card>
</template>

<script>
export default {
  name: 'ModuleSelector',
  props: {
    currentModule: String,
    moduleNames: Array
  },
  emits: ['update:currentModule']
}
</script>
